import style from '../../styles/pages/experiencias/experienciaNuevas.module.scss';

type card = {
  tittel: string;
  image: string;
  contents: contents[];
};

type contents = {
  description: string;
  logo: string;
};

export default function Card(datos: card) {
  let logo = `url(${datos.image})`;
  return (
    <>
      <div className={style.card}>
        <div className={style.header} style={{ backgroundImage: logo }}>
          <div>{datos.tittel}</div>
        </div>
        <div className={style.body}>
          {datos.contents.map((content) => {
            return (
              <div>
                <img src={content.logo} alt="icon" />
                <p>{content.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
